export default {
  it: {
    slides: [
      {
        h1: 'Essere',
        p: 'Media-neutrality, indipendenza ed expertise. L’unica verità che conosciamo è quella che si basa su (il raggiungimento di) risultati concreti.',
        a: '',
        h: '#85242D',
        c: '0x85242D',
      },
      {
        h1: 'Elevare',
        p: 'Dati, strategia, creatività. Leggiamo l’oggi per poter costruire, insieme, la campagna di successo di domani.',
        a: 'services',
        h: '#EA9E25',
        c: '0xEA9E25',
      },
      {
        h1: 'Unire',
        p: 'Coesione, cultura ed etica. Trasparenza ad ogni costo e relazioni di valore da costruire con un team tagliato a vostra misura.',
        a: 'team',
        h: '#2387b2',
        c: '0x2387b2',
      },
    ],
  },
  en: {
    slides: [
      {
        h1: 'Being',
        p: 'Media-neutrality, independence and expertise. The only truth we know is the one based on (achieved) real results.',
        a: '',
        h: '#85242D',
        c: '0x85242D',
      },
      {
        h1: 'Elevate',
        p: 'Data, strategy, creativity.We interpret today to build, together, the successful campaigns of tomorrow.',
        a: 'services',
        h: '#EA9E25',
        c: '0xEA9E25',
      },
      {
        h1: 'Unite',
        p: 'Cohesion, cultures and ethics. Transparency at all costs and valuable relationships to be created via a custom built team.',
        a: 'team',
        h: '#2387b2',
        c: '0x2387b2',
      },
    ],
  },
};
